/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signing_InInputs */

const fr_auth_signing_in = /** @type {(inputs: Auth_Signing_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connexion…`)
};

const en_auth_signing_in = /** @type {(inputs: Auth_Signing_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signing in…`)
};

/**
* | output |
* | --- |
* | "Signing in…" |
*
* @param {Auth_Signing_InInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_signing_in = /** @type {((inputs?: Auth_Signing_InInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signing_InInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_signing_in(inputs)
	return fr_auth_signing_in(inputs)
});